<template>
  <!-- 选做题 -->
  <!-- <div class="choose-topic topic-box">
    <div class="topic-th" v-if="!msg.resolveNum">
      {{msg.th}}、{{msg.name}}（{{msg.fsTotal || 20}}分）
      <div v-if="answerSheet.acCardYJType==2" class="score-box">
        <div class="s-text">
          得
          <br />分
        </div>
      </div>
    </div>
    <div v-for="(group, index) in msg.htmlArray" :key="'group' + index">
      <div class="topic-bd choose-cont">
        <div class="topic-desc">
          选做题目:
          <span v-for="(th, idx) in group.thList" :key="'gth' + idx" class="th-item">
            {{th}}
            <i class="th-fill"></i>
          </span>
        </div>
        <ckeditor :editor="editor" v-model="group.innerHTML" :config="editorConfig"></ckeditor>
      </div>
    </div>
  </div>-->
  <div
    class="fill-topic topic-box"
    @mouseleave="showTopicEditorBox = false"
    @mouseenter="handleMouseEnter"
  >
    <!-- <div
      v-for="(group, index) in msg.htmlArray"
      class="answer-group answer-topic topic-box"
      :key="'group' + index"
      @click.stop.prevent="editBox(index)"
    >-->
    <div class="topic-th" v-if="msg.hasTitle">
      <EditScoreBox
        :msg="msg"
        @myBlur="handlerBlur"
        :isPreview="isPreview"
      ></EditScoreBox>
    </div>
    <div v-else>
      <EditScoreBox
        :msg="msg"
        @myBlur="handlerBlur"
        :isPreview="isPreview"
      ></EditScoreBox>
    </div>
    <div
      class="topic-bd fill-cont answer-cont choose-cont"
      :class="`${msg.hasTitle ? 'choose-cont-hastitle' : ''}`"
      :style="{
        height: (msg.initDragHeight || 300) + 'px',
        border: showTopicEditorBox ? '1px solid #409eff !important' : '',
      }"
    >
      <TopicEditBox
        v-if="showTopicEditorBox"
        position="top:5px"
        :msg="msg"
      ></TopicEditBox>
      <div class="drag_mark" v-show="showTopicEditorBox"></div>
      <!-- <div v-if="answerSheet.acCardYJType==1" class="score-box">
            <div class="s-text">
              得
              <br />分
            </div>
      </div>-->
      <!-- <template v-if="isPreview">
            <div v-html="group.innerHTML"></div>
      </template>-->
      <!-- <template v-else> -->
      <!--<custom-edit-box v-if="!group.resolveNum&&group.isEdit" :msg="msg" :gi="index" :isDis="isDis" style="top:10px;"/>-->
      <div class="choose-cont">
        <div class="topic-desc" v-show="msg.hasTitle">
          选做题目:
          <span
            v-for="(th, idx) in msg.thList"
            :key="'gth' + idx"
            class="th-item"
          >
            {{ th }}
            <i class="th-fill"></i>
          </span>
        </div>
      </div>
      <!-- <div>{{msg}}</div> -->
      <!-- <ckeditor :editor="editor" v-model="msg.innerHTML" :config="editorConfig"></ckeditor> -->
      <template v-if="isPreview">
        <div
          class="ck-content"
          v-html="html"
        ></div>
      </template>
      <template v-if="!isPreview">
        <MyUEditor
          :msg="msg"
          @onMouseEnter="showTopicEditorBox = false"
          @onBlur="handleBlur"
        ></MyUEditor>
      </template>
      <!-- <div class="move-h" :id="answerMove + index" v-show="group.resolveEnd&&group.isEdit">
              <span class="el-icon-sort"></span>
            </div>
      </template>-->

      <!--主体-->
    </div>
    <div class="drag_button" id="drag_button" v-show="showTopicEditorBox">
      <i class="el-icon-rank" style="font-size: 22px"></i>
    </div>
  </div>
  <!--主体-->
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import { mouseEventMixins } from "../../mixins/mouseEvent.mixins";
import { editScoreBoxMixins } from "../../mixins/editScoreBox.mixins";
import FillTopic from "@/assets/js/utils/FillTopic";
import MyDrag from "@/assets/js/utils/base/MyDrag";
import { TAG_P_HEIGHT } from "@/subjects/constant";
export default {
  name: "fillTopic",
  props: {
    msg: { innerHTML: "" },
    isPreview: Boolean,
  },
  mixins: [mouseEventMixins, editScoreBoxMixins],
  components: {},
  computed: {
    ...mapState("card", {
      answerSignal: (state) => state.answerSignal,
      existHeight: (state) => state.existHeight,
      pageCell: (state) => state.pageCell,
      subjects: (state) => state.subjects,
      currentPageNum: (state) => state.currentPageNum,
      newTopicHeight: (state) => state.newTopicHeight,
    }),
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    rowNum() {
      if (this.msg.typesItem.rowNum < 1) {
        return this.msg.typesItem.rowNum.toString().split(".");
      } else {
        return [this.msg.typesItem.rowNum];
      }
    },
    html: function () {
      console.log(this.msg.innerHTML);
      return this.msg.innerHTML
        .replace(/<p class="row"><\/p>/g, '<p class="row">&#8203;</p>')
        .replace(/<p class=""><\/p>/g, '<p class="row">&#8203;</p>')
        .replace(/<p class><\/p>/g, '<p class="row">&#8203;</p>');
    },
  },

  data(ctx) {
    return {
      showTopicEditorBox: false,
      myFillTopic: undefined,
      myDrag: undefined,
      editor: ctx.$ckEditor,
    };
  },
  created() {},
  mounted() {
    const target = document.querySelectorAll(".topic-bd");
    this.myDrag = new MyDrag(target);
    this.myFillTopic = new FillTopic({
      width: 1107,
      height: 706,
      canDrag: true,
      myDrag: this.myDrag,
    });
    this.myFillTopic.init();
    // setTimeout(() => {
    //   console.log("哈哈哈哈", this.answerSignal, this.msg);
    //   if (this.answerSignal) {
    //     myFillTopic.recursionCutAnswerPage(
    //       this.pageCell.length - 1,
    //       this.existHeight,
    //       undefined,
    //       false
    //     );
    //     this.setAnswerSignal(false);
    //   }
    // }, 200);
  },
  methods: {
    ...mapMutations({
      setAnswerSignal: "card/setAnswerSignal",
      setCurrentPageNum: "card/setCurrentPageNum",
      updatePageCell: "card/updatePageCell",
      updateSubjects: "card/updateSubjects",
    }),
    async handleBlur(data) {
      const { editorHeight, content, overstepDistance } = data;
      this.setCurrentPageNum(this.msg.pageIndex);
      await this.updatePageCell({
        currentIndexInPage: this.msg.currentIndexInPage,
        initDragHeight: editorHeight,
        innerHTML: content,
      });
      this.deconstruction();
      const timer = setTimeout(() => {
        overstepDistance > 0 &&
          this.myFillTopic.updateViewHeight(
            overstepDistance,
            undefined,
            undefined,
            "blur"
          );
        clearTimeout(timer);
      }, 200);
    },
    deconstruction() {
      const timerUpdate = setTimeout(() => {
        // 这里最好使用异步的方法处理 不影响其他代码的执行
        // 在这里处理自定义编辑的问题 blur的时候把高度 html存储到subjects里面去
        // 记录当前编辑的subject下标 循环的时候把使用下标让上面的题型保持不变 下面的题型重新appendToPage
        let sameTopicList = []; // 把整个页面的pagecell的filltopiclist中属于该题号的题型stack存起来
        this.pageCell.forEach((page) => {
          page.fillTopiclist.forEach((topic) => {
            if (topic.th == this.msg.th) {
              sameTopicList.push(topic);
            }
          });
        });
        let subjectContainer = { initDragHeight: 0, innerHTML: "" }; // 用来存储html和高度
        this.subjects.forEach(async (subject, index) => {
          if (subject.th == this.msg.th) {
            // 题号相等的说明属于该题型的分解 然后记录下该下标
            sameTopicList.forEach((sameTopic) => {
              subjectContainer.initDragHeight += sameTopic.initDragHeight || 0; //给subject对象赋予高度
              subjectContainer.innerHTML += sameTopic.innerHTML || "";
            });
            subject.setHtml(subjectContainer.innerHTML);
            subject.setInitDragHeight(subjectContainer.initDragHeight);
            subject.setFromEdit(false);
            let result = [];
            const map = {}; //用来存储合并之后的数据
            sameTopicList.forEach((sameTopic, sameTopicIndex) => {
              // 合并分解的题型 还原到subjects里面去
              if (map[sameTopic.no]) {
                map[sameTopic.no] = {
                  ...map[sameTopic.no],
                  initDragHeight:
                    map[sameTopic.no].initDragHeight + sameTopic.initDragHeight,
                  innerHTML: map[sameTopic.no].innerHTML + sameTopic.innerHTML,
                };
              } else {
                map[sameTopic.no] = sameTopic;
              }
            });
            Object.keys(map).forEach((key) => {
              result.push(map[key]);
            }); // 拿到合并的数组之后 然后再set到对象的htmlArray中去
            subject.setHtmlArray(result);
            await this.updateSubjects({
              index: index,
              data: subject,
            });
          }
        });
        console.log(
          "解答题失焦处理的数据",
          this.msg,
          this.subjects,
          sameTopicList
        );
        clearTimeout(timerUpdate);
      }, 100);
    },
    handleMouseDown() {},
  },
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
.choose-cont .ck-content p {
  // margin-top: 10px !important;
}
// .choose-cont .ck-content.ck-editor__editable_inline > :first-child {
//   margin-top: 35px !important;
// }
.topic-desc {
  margin: 10px 0 35px;
  position: relative;
  top: 0;
  left: 15px;
  .th-item {
    display: inline-block;
    margin-right: 8px;
  }
  .th-fill {
    display: inline-block;
    width: 16px;
    height: 8px;
    border: 1px solid #000;
    margin-left: 3px;
  }
}
</style>
